// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".platform-buttom-list[data-v-2cdc501a]{margin-top:-43px!important}", ""]);
// Exports
module.exports = exports;
